let APP_CONFIG
if (process.env.NODE_ENV === 'production') {
    APP_CONFIG = {
        channelCode : 'DEFAULT',
         chatbotUrl : '/ichat_api_v2',
//        chatbotUrl : 'http://localhost:8080/ichat_api_v2',
        getGreeting : '/message/greeting',
        sendQuestion : '/message/send',
        sendTrigger : '/message/trigger',
        sendPostback : '/message/postback',
        getArk : '/ark',
        getRealtimeAnswer : '/realTimeAnswer',
		getEvent : '/feedback/getEvent',
		writeEvent : '/feedback/writeEvent',
		getFeedback : '/feedback/getFeedback',
        writeFeedback : '/feedback/writeFeedback',
		getPush : '/message/getPush',
        logIn : 'https://chat.cau.ac.kr/ichat_api_v2/nets/login.jsp?retUrl='+ encodeURIComponent(window.location.protocol + "//" + window.location.host  + window.location.pathname  + window.location.search),
        logOut : 'https://sso4.cau.ac.kr/sso/logoutService.do?ssosite=chat::chat.cau.ac.kr&returnURL='+ encodeURIComponent(window.location.protocol + "//" + window.location.host  + window.location.pathname  + window.location.search),
        getSetting : '/setting/get',
        setSetting : '/setting/set',
        popWinTarget : '_blank',
        maxSetting : 5,
        privacyLink : 'https://www.cau.ac.kr/cms/FR_CON/index.do?MENU_ID=2840',
        useLogin : false,
        // timeout : 20000,
        timeout : 100000,
        getSsoStatus : '/getSsoStatus',  //챗봇 인터페이스 내 중앙대 SSO 상태값 조회용 API
            // GPT 전용
        getGpt: '/setting/getGpt',
        setGpt: '/setting/setGpt'
    }
} else {
    APP_CONFIG = {
        channelCode : "DEFAULT",
         chatbotUrl : 'https://chat.cau.ac.kr/ichat_api_v2',
//        chatbotUrl : 'http://localhost:8080/ichat_api_v2',

        getGreeting : '/message/greeting',
        sendQuestion : '/message/send',
        sendTrigger : '/message/trigger',
        sendPostback : '/message/postback',
        getArk : '/ark',
        getRealtimeAnswer : '/realTimeAnswer',
		getEvent : '/feedback/getEvent',
		writeEvent : '/feedback/writeEvent',
		getFeedback : '/feedback/getFeedback',
        writeFeedback : '/feedback/writeFeedback',
		getPush : '/message/getPush',
        logIn : 'https://chat.cau.ac.kr/ichat_api_v2/nets/login.jsp?retUrl='+ encodeURIComponent(window.location.protocol + "//" + window.location.host  + window.location.pathname  + window.location.search),
        logOut : 'https://sso4.cau.ac.kr/sso/logoutService.do?ssosite=chat::chat.cau.ac.kr&returnURL='+ encodeURIComponent(window.location.protocol + "//" + window.location.host  + window.location.pathname  + window.location.search),
        getSetting : '/setting/get',
        setSetting : '/setting/set',
        popWinTarget : '_blank',
        maxSetting : 5,
        privacyLink : 'https://www.cau.ac.kr/cms/FR_CON/index.do?MENU_ID=2840',
        useLogin : false,   //true:로그인 해야지만 서비스 이용가능, false:로그인 하지 않아도 질의응답 가능.
        
        // timeout : 20000,
         timeout : 100000,
        getSsoStatus : '/getSsoStatus',  //챗봇 인터페이스 내 중앙대 SSO 상태값 조회용 API
                // GPT 전용
        getGpt: '/setting/getGpt',
        setGpt: '/setting/setGpt'

    }
}

const NEED_LOGIN_TEMPLATE = {
    "outputs": [
        {
            "simpleText": {
                "text": "찰리를 이용하려면 로그인이 필요해요. 😃<br/><br/>포탈 계정으로 로그인 후 다시 질문 해 줄래요?",
                "buttons": [
                    {
                        "label": "로그인 하기",
                        "action": "webLink",
                        "webLinkUrl": 'https://chat.cau.ac.kr/ichat_api/nets/login.jsp?retURL='+window.location.protocol + "//" + window.location.host  + window.location.pathname  + window.location.search,
                        "target": "_self"
                    }
                ]
            }
        }
    ],
    "quickReplies": null
}

const DEFAULT_GREETING_TEMPLATE = {
    "outputs": [
        {
            "simpleText": {
                "text": "안녕하세요 찰리입니다. 🙂"
            }
        },
        
    ],
    "quickReplies" : null 
}

const DEFAULT_SETTING = {
    "data" : {
        "useArk": true,
        "menuPosition": "right",
        "greeting": null,
        "quickMenu": [
            {
                "isUse": "1",
                "id": 1,
                "label": "학사 일정",
                "utterance": "학사 일정이 궁금해요"
            },
            {
                "isUse": "1",
                "id": 4,
                "label": "셔틀 버스",
                "utterance": "셔틀 버스 시간표"
            },
            {
                "isUse": "1",
                "id": 5,
                "label": "캠퍼스 맵",
                "utterance": "캠퍼스 지도"
            },
            {
                "isUse": "1",
                "id": 6,
                "label": "편의시설",
                "utterance": "편의시설"
            },
            {
                "isUse": "1",
                "id": 7,
                "label": "학식 메뉴",
                "utterance": "학식 메뉴"
            }
        ],
        "state": {
            "code": 0,
            "detail": "SUCCESS"
        }
    }
}

const USE_TIP_TEMPLATE = {
    "outputs": [
        {
            "simpleText": {
                "text": "찰리를 효과적으로 사용할 수 있는 이용tip을 알려드릴게요!"
            }
        },
        {
            "carousel": {
                "type": "basicCard",
                "items": [
                    {
                        "thumbnail": {
                            "imageUrl": "https://chat.cau.ac.kr/upload_image/card_tip_button.png",
                            "link": {
                                "web": ""
                            }
                        },
                        "description": "어떤 질문을 해야하는지, 내용과 관련하여 알아야 할 정보가 무엇인지 궁금할 땐 준비된 버튼을 눌러 주요한 정보를 확인할 수 있어요.😃"
                    },
                    {
                        "thumbnail": {
                            "imageUrl": "https://chat.cau.ac.kr/upload_image/card_tip_inputtext.png",
                            "link": {
                                "web": ""
                            }
                        },
                        "description": "궁금한 내용을 직접 질문하고 싶다면 텍스트 입력창에 입력해주세요.😘"
                    },
                    {
                        "thumbnail": {
                            "imageUrl": "https://chat.cau.ac.kr/upload_image/card_tip_greeting.png",
                            "link": {
                                "web": ""
                            }
                        },
                        "description": "원하는 정보를 대화 시작과 함께 확인하고 싶다면, 메뉴(≡) → 설정(⚙)에서 그리팅메시지를 선택해주세요.😉"
                    },
                    {
                        "thumbnail": {
                            "imageUrl": "https://chat.cau.ac.kr/upload_image/card_tip_quick.png",
                            "link": {
                                "web": ""
                            },
                            "fixedRatio": "false"
                        },
                        "description": "메뉴(≡)에는 빠르게 사용할 수 있는 퀵메뉴가 준비되어 있어요. 퀵메뉴는 설정(⚙) 에서 원하는 대로 선택할 수 있어요.😊"
                    },
                    {
                        "thumbnail": {
                            "imageUrl": "https://chat.cau.ac.kr/upload_image/card_tip_auto.png",
                            "link": {
                                "web": ""
                            },
                            "fixedRatio": "false"
                        },
                        "description": "질문 자동완성 버튼은 메뉴(≡) → 설정(⚙)에서 끄거나 켤 수 있어요.😘"
                    }
                ]
            }
        },
        {
            "carousel": {
                "type": "basicCard",
                "items": [
                    {
                        "thumbnail": {
                            "imageUrl": "https://chat.cau.ac.kr/upload_image/card_tip_home.png",
                            "link": {
                                "web": ""
                            },
                            "fixedRatio": "false"
                        },
                        "description": "모바일 OS에 따른 방법을 확인해 볼까요?😃",
                        "title": "모바일에서 편리하게 챗봇 실행하는 법"
                    },
                    {
                        "thumbnail": {
                            "imageUrl": "https://chat.cau.ac.kr/upload_image/card_tip_android.png",
                            "link": {
                                "web": ""
                            },
                            "fixedRatio": "false"
                        },
                        "description": "2. 앱 메뉴(···)에서 홈 화면 추가 선택",
                        "title": "1. 네이버, 크롬 등에서 챗봇 접속"
                    },
                    {
                        "thumbnail": {
                            "imageUrl": "https://chat.cau.ac.kr/upload_image/card_tip_ios.png",
                            "link": {
                                "web": ""
                            },
                            "fixedRatio": "false"
                        },
                        "description": "2. 공유 버튼 > 홈 화면에 추가 선택",
                        "title": "1. 사파리 앱에서 챗봇 접속"
                    }
                ]
            }
        }
    ],
    "quickReplies": null
}

const DEFAULT_ERROR = {
    "outputs": [
        {
            "simpleText": {
                "text": "앗, 챗봇 서비스 점검 중이네요😢 잠시 후에 다시 질문해줄래요?"
            }
        },
    ],
    "quickReplies": null
}

const DEFAULT_ERROR_EN = {
    "outputs": [
        {
            "simpleText": {
                "text": "The chatbot service is undergoing maintenance😢 Please try again later."
            }
        },
    ],
    "quickReplies": null
}

const DEFAULT_ERROR_CN = {
    "outputs": [
        {
            "simpleText": {
                "text": "chatbot服务正在维护中。😢 请稍后再试一下。"
            }
        },
    ],
    "quickReplies": null
}



const DEFAULT_ERROR_JA = {
    "outputs": [
        {
            "simpleText": {
                "text": "ああ、チャットボットサービスをチェックしています😢しばらくしてからもう一度質問してください。 请稍后再试一下。"
            }
        },
    ],
    "quickReplies": null
}



const DEFAULT_ERROR_VI = {
    "outputs": [
        {
            "simpleText": {
                "text": "Ồ, dịch vụ chatbot đang được bảo trì😢 Bạn có thể hỏi lại tôi sau được không? 请稍后再试一下。"
            }
        },
    ],
    "quickReplies": null
}



const ALLOW_KEYWORD = ["이용팁","이용tip","이용 가이드","이용 Tip","Tip","사용","이용","방법","가이드","이용가이드","이용 팁","사용 방법","이용방법","사용방법","이용법","이용 안내","이용안내","사용법","쓰는법","사용 안내","사용안내","쓰는 법","도움말","이용 방법",]

export { APP_CONFIG, NEED_LOGIN_TEMPLATE, DEFAULT_GREETING_TEMPLATE, DEFAULT_SETTING, ALLOW_KEYWORD, USE_TIP_TEMPLATE, DEFAULT_ERROR, DEFAULT_ERROR_EN, DEFAULT_ERROR_CN, DEFAULT_ERROR_JA, DEFAULT_ERROR_VI};